export function Button2(props) {
  const { texto, icono, onClick, loading } = props;

  const click = (e) => {
    e.preventDefault();
    if (loading) return;
    onClick();
  };

  return (
    <button onClick={click}>
      <span>{texto}</span>
    </button>
  );
}
